import classNames from "classnames";
import React from "react";

interface TabsProps {
  activeTab: string;
  tabs: string[];
  setActiveTab: any;
  variant?: "pill" | "underline";
  className?: string;
}

const Tabs = (props: TabsProps) => {
  const { activeTab, tabs, setActiveTab, variant = "pill", className } = props;

  if (variant === "underline") {
    return (
      <div className={classNames("flex border-b border-gray-200", className)}>
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={classNames(
              "text-[14px] py-3 px-5 font-medium transition-colors duration-150 whitespace-nowrap",
              {
                "border-b-2 border-[#0979A1] text-[#0979A1] -mb-px": activeTab === tab,
                "text-gray-500 hover:text-gray-700": activeTab !== tab,
              }
            )}
            onClick={() => setActiveTab(tab)}>
            {tab}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className={classNames("flex w-[400px] h-[50px] bg-[#CFF0FC] rounded-lg px-2 mt-9", className)}>
      {tabs.map((tab, index) => (
        <button
          key={index}
          className={classNames(
            "text-[12px] flex-1 md:py-2 px-4 md:px-8 capitalize min-w-fit",
            {
              "bg-[#0979A1] text-[#fff] rounded-lg my-2 font-medium transition-all duration-1000":
                activeTab === tab,
            }
          )}
          onClick={() => setActiveTab(tab)}>
          {tab}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
